// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_b2-0";
export var headerCellHover = "_b2-1";
export var readCellContainer = "_b2-2";
export var readCellSlot = "_b2-3";
export var rowHoverCheckbox = "_b2-4";
export var rowUnreadIndicator = "_b2-5";
export var searchHighlight = "_b2-8";
export var supportTicketRow = "_b2-6";
export var unreadIndicator = "_b2-7";